// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"612":"ce335717c117ec112980","756":"e8ff8ea2610e997062e5"}[chunkId] + ".js";
};